export default __webpack_public_path__ + "app/assets/images/dashboard/img-chat-6094fe9ebe5ddd60bde1591ed7b3277f.png";